import { render, staticRenderFns } from "./SubmittedStartupsTable.vue?vue&type=template&id=72c41954&scoped=true&"
import script from "./SubmittedStartupsTable.vue?vue&type=script&setup=true&lang=js&"
export * from "./SubmittedStartupsTable.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c41954",
  null
  
)

export default component.exports